import { Platform } from 'react-native'

import Button from 'app/components/base/Button'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

export interface BadgeProps {
  label: React.ReactNode
  value: string
  disabled?: boolean
  onClick?: (value: string) => void
}

const Badge: RFC<BadgeProps> = ({ label, value, onClick, disabled }) => {
  const handleClick = () => {
    if (onClick) onClick(value)
  }

  return (
    <Button
      type="button"
      value={value}
      sx={{
        borderRadius: 1.25,
        backgroundColor: 'border.main',
        paddingX: 1,
        paddingY: 0,
        minHeight: 2.75,
        ...Platform.select({
          web: {
            width: 'max-content',
            '&:hover': {
              backgroundColor: 'background.hover',
              '& .MuiTypography-root': {
                color: 'common.white'
              }
            },
            '&.Mui-disabled': {
              backgroundColor: 'border.main',
              border: 'none'
            }
          },
          native: {
            flexShrink: 0
          }
        })
      }}
      onClick={handleClick}
      disabled={disabled}
    >
      <Text
        variant="subtitle2"
        sx={{ fontWeight: 500, color: 'text.primary' }}
        {...(!IS_NATIVE_APP && { component: 'p' })}
      >
        {label}
      </Text>
    </Button>
  )
}

export default Badge
